<div class="modal-header">
</div>
<div class="modal-body">
  <p i18n class="mb-0 text-center title">Your account was banned for<span> {{duration}} days</span> by Admin of the website</p>
  <p i18n class="mb-0 text-center content">Now you can’t use this website.</p>
</div>
<div class="modal-footer">
</div>
